import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "bg-modal w-maxC",
  style: {"width":"minmax(8rem, max-content)"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row gap-02 mleft-04" }
const _hoisted_4 = { class: "row-bottom" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "pad-l" }
const _hoisted_7 = {
  key: 0,
  style: {"min-height":"45rem","min-width":"34rem"}
}
const _hoisted_8 = ["src"]

import { ref, onMounted } from 'vue';
import gen from '@/functions/general.js';
import officeapi from '@/api/officeapi';


export default /*@__PURE__*/_defineComponent({
  __name: 'showTiersPayant',
  props: {
    tpUuid: {
      type: String,
      required: true,
    },
},
  setup(__props) {

const props = __props

const isLoading = ref(true);
const localPdfBlob = ref(null)
const localPdfUrl = ref(null)
const hasNoDocument = ref(false)

async function showPdf() {
  await getPdf()
  if (!localPdfUrl.value) {return}
  window.open(localPdfUrl.value)
}

async function downloadPdf() {
  await getPdf()
  if (!localPdfBlob.value) {return}
  const fileName = "TP relevé CNS"
  const fileExtension = "pdf"
  gen.downloadBlob(localPdfBlob.value, fileName, fileExtension)
}

async function printPdf() {
  await getPdf()
  if (!localPdfBlob.value) {return}
  gen.printBlob(localPdfBlob.value, "Pdf")
}

async function getPdf() {
  if (localPdfBlob.value != null) {return;}
  isLoading.value = true;
  const respBlob = await officeapi.getTpPdfStream(props.tpUuid)
  isLoading.value = false;
  if (!respBlob) {hasNoDocument.value = true; return; }
  localPdfBlob.value = respBlob
  const myBlob= new Blob([respBlob], {type: 'application/pdf'})
  localPdfUrl.value = window.URL.createObjectURL(myBlob)
}

const invoicesPdfBlob = ref(null)

async function printInvoicesPdf() {
  await getInvoicesPdf()
  if (!invoicesPdfBlob.value) {return}
  gen.printBlob(invoicesPdfBlob.value, "Pdf")
}

async function getInvoicesPdf() {
  if (invoicesPdfBlob.value != null) {return;}
  isLoading.value = true;
  const respBlob = await officeapi.getTpInvoicesPdfStream(props.tpUuid)
  isLoading.value = false;
  if (!respBlob) {return}
  invoicesPdfBlob.value = respBlob
}

onMounted(async () => {
    await getPdf();
});


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value === true)
      ? (_openBlock(), _createBlock(_component_text_item, {
          key: 0,
          txt: "Loading ...",
          styles: "main-l"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_buttonGroup, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showPdf()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "fullScreen",
                    styles: "main-m"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_buttonGroup, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadPdf()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "download",
                    styles: "main-m"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_buttonGroup, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (printPdf()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_svg_item, {
                      icon: "printer",
                      styles: "main-l size-m"
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mleft-auto" }, null, -1)),
            _createVNode(_component_buttonGroup, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (printInvoicesPdf()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_svg_item, {
                    icon: "printer",
                    styles: "main-l size-m"
                  }),
                  _createVNode(_component_text_item, {
                    txt: "Imprimer tous les MH",
                    styles: "main-l",
                    class: "mleft-04"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            (localPdfUrl.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("iframe", {
                    src: localPdfUrl.value,
                    scrolling: "yes",
                    frameborder: "1",
                    style: {"height":"45rem","width":"100%"}
                  }, null, 8, _hoisted_8)
                ]))
              : (hasNoDocument.value)
                ? (_openBlock(), _createBlock(_component_text_item, {
                    key: 1,
                    txt: "Pas de fichier à afficher",
                    styles: "main-l"
                  }))
                : _createCommentVNode("", true)
          ])
        ], 64))
  ]))
}
}

})